import React from 'react'
import './Possibility.css'

const Possibility = () => {
  return (
    <div>Possibility</div>
  )
}

export default Possibility